import React, { useEffect, useState } from 'react';
import { BarChart } from '@mui/x-charts/BarChart';

import ConnectionFinder from '../../api/ConnectionFinder';

import '../styles/PrivateAnalytics.css'; // Assuming you have some styles for the analytics page

const PrivateAnalytics = () => {

    const [data, setData] = useState([]);
    const [resTable, setResTable] = useState();

    useEffect(() => {
    ConnectionFinder.get("/internal_analytics/listReasearchCount",
        {
            headers: {
                "x-access-token": localStorage.getItem('token')
            }
        }
    ).then((response) => {
        setData(
            <BarChart
                xAxis={[{ scaleType: 'band', data: response.data[1].map(e => e.date)}]}
                yAxis={[{label: 'Ricerche'}]}
                series={[
                    { data: [...response.data[1].map(e => e.resNum)], label: 'Totale', color: '#ff0f64' }, //Totale
                    { data: [...response.data[2].map(e => e.resNum)], label: 'Operatori', color: '#c9cfcf' }, //Operatori
                    // { data: [14, 6, 5, 8, 9], label: 'Series B1' },
                ]}
                barLabel={(item, context) => {
                    if ((item.value ?? 0) > 10) {
                    return 'High';
                    }
                    return context.bar.height < 60 ? null : item.value?.toString();
                }}
                height={350}
            />
        )
        setResTable(
            <table className='resTable'>
                <thead>
                    <tr>
                        <th>Utente</th>
                        <th>Ruolo</th>
                        <th>Data</th>
                        <th>Ricerche</th>
                    </tr>
                </thead>
                <tbody>
                    {response.data[0].map(e => (
                        <tr>
                            <td>{e.username}</td>
                            <td>{e.role}</td>
                            <td>{e.date}</td>
                            <td>{e.resNum}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        )
    }
    )}, [])

    return (
        <div style={{ padding: '20px', width: '90%', margin: 'auto'}}>
            <h1>Private Analytics</h1>
            <p>Dati riguardo l'utilizzo della parte privata di fiberfinder.</p>
            {data}
            <h2>Richieste per utente</h2>
            <div style={{overflowY: 'scroll', maxHeight: '200px'}}>
                {resTable}
            </div>
        </div>
    );
}

export default PrivateAnalytics;